import { render, staticRenderFns } from "./_step.vue?vue&type=template&id=0845210e&"
import script from "./_step.vue?vue&type=script&lang=js&"
export * from "./_step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0845210e')) {
      api.createRecord('0845210e', component.options)
    } else {
      api.reload('0845210e', component.options)
    }
    module.hot.accept("./_step.vue?vue&type=template&id=0845210e&", function () {
      api.rerender('0845210e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/_poll/_step.vue"
export default component.exports